import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { QueryParam } from '../../../../query-param'
import { RouteParam } from '../../../../route-param'
import type { TypeParams } from '../types'

/**
 * Synchronizes the selected scenario with admin route parameter
 * ({@link RouteParam.ScenarioId}) while preserving fallback to
 * query-param alias sync ({@link QueryParam.ScenarioAlias}).
 */
export const syncCurrentEntityWithUrl = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    scenariosEc: ec.Collection<TypeParams>,
    _router: router.Router,
  ) =>
    _router.selectors.getRouteParam(RouteParam.ScenarioId).asObservable.pipe(
      rxjs.combineLatestWith(
        _router.selectors.getQueryParam(QueryParam.ScenarioAlias).asObservable,
        scenariosEc.plugins.currentListPlugin.feature.selectors.entities
          .asObservable,
        scenariosEc.plugins.currentEntityPlugin.feature.selectors.getId()
          .asObservable,
      ),
      rxjs.map(
        ([routeScenarioId, routeAlias, scenarios, currentScenarioId]) => {
          const queryParamScenarioId = scenarios.find(
            scenario => scenario.alias === routeAlias,
          )?.id
          const nextScenarioId = routeScenarioId ?? queryParamScenarioId

          return nextScenarioId !== currentScenarioId
            ? scenariosEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                .from('syncCurrentEntityWithUrl (effect)')
                .create({
                  value: nextScenarioId,
                })
            : store.effects.SKIP
        },
      ),
    ),
)

// TODO Use this code as effect once scenario management in the main app is
// refactored to use scenarios from the 'me' feature.
// /**
//  * Synchronizes the selected entity with the ScenarioId route parameter.
//  * Updates the current entity selection when the URL parameter changes.
//    */
// export const syncCurrentEntityWithUrl = store.effects.create(
//   (
//     feature: ec.Collection<TypeParams>['feature'],
//     scenariosEc: ec.Collection<TypeParams>,
//     _router: router.Router,
//   ) =>
//     _router.selectors.getRouteParam(RouteParam.ScenarioId).asObservable.pipe(
//       rxjs.withLatestFrom(
//         scenariosEc.plugins.currentEntityPlugin.feature.selectors.getId()
//           .asObservable,
//       ),
//       rxjs.map(([routeId, id]) =>
//         id !== routeId
//           ? scenariosEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
//               .from('syncCurrentEntityWithUrl (effect)')
//               .create({
//                 value: routeId,
//               })
//           : store.effects.SKIP,
//       ),
//     ),
// )
